
import { Component, Vue, Prop } from 'vue-property-decorator';
import { TradeCountReportChart } from 'ah-reports';

@Component({
  components: { TradeCountReportChart },
})
export default class TradeCountReportDashboardWidget extends Vue {
  @Prop({ required: true }) fromDate!: Date;

  @Prop({ required: true }) toDate!: Date;
}
